module.exports = __webpack_public_path__ + "assets/img/e31e22e22aeaa4fb91db88ad84db5968.png";